var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }